import { lifeCycleEntitiesMap } from '../constants/lifeCycle';

export const getChangedLifeCycleData = (room, lifeCycle) => {
  const {
    stageAddressLifeCycle,
    stepAddressLifeCycle,
    acceptanceStatusAddressLifeCycle,
  } = room.addressLifeCycle;

  const { stage, step, acceptanceStatus } = lifeCycle;

  const result = [];

  if (stage.id !== stageAddressLifeCycle.id) {
    result.push({
      type: lifeCycleEntitiesMap.stage,
      title: 'Стадия',
      current: stageAddressLifeCycle?.name,
      actual: stage?.name,
    });
  }

  if (step.id !== stepAddressLifeCycle.id) {
    result.push({
      type: lifeCycleEntitiesMap.step,
      title: 'Этап',
      current: stepAddressLifeCycle?.name,
      actual: step?.name,
    });
  }

  if (acceptanceStatus?.id !== acceptanceStatusAddressLifeCycle?.id) {
    result.push({
      type: lifeCycleEntitiesMap.acceptanceStatus,
      title: 'Результат приемки',
      current: acceptanceStatusAddressLifeCycle?.name,
      actual: acceptanceStatus?.name,
    });
  }

  return result.length ? result : null;
};
